import { render, staticRenderFns } from "./loaderModal.vue?vue&type=template&id=5bd514e7&scoped=true&"
import script from "./loaderModal.vue?vue&type=script&lang=js&"
export * from "./loaderModal.vue?vue&type=script&lang=js&"
import style0 from "./loaderModal.vue?vue&type=style&index=0&id=5bd514e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd514e7",
  null
  
)

export default component.exports